<template>
  <a-layout>
    <Breadcrumb />
    <div class="page-title-container">
      <span class="page-title">合作方</span>
      <div class="action-container">
        <a-button type="primary" icon="plus" @click="goAdd" class="page-title-btn">
          新建
        </a-button>
      </div>
    </div>
    <div class="content-container">
      <div class="search-container">
        <a-input placeholder="合作方名称" v-model="keyword" class="medium-search-input">
          <a-icon slot="prefix" type="search" />
        </a-input>
        <a-button
            @click="onSearch"
            class="search-btn"
        >搜索</a-button
        >
      </div>
      <div class="list-container">
        <a-table
            :columns="tblColumns"
            :data-source="tblData"
            :pagination="pagination"
            :loading="loading"
            rowKey="projectId"
            @change="onTableChange"
        >
          <a-space slot="action" slot-scope="record">
            <a @click="onEdit(record)">修改</a>
            <a @click="onDelete(record)" class="danger-text">删除</a>
          </a-space>
        </a-table>
      </div>
    </div>

    <a-modal
        :title="modalTitle"
        :visible="visible"
        :confirm-loading="confirmLoading"
        okText="确定"
        cancelText="取消"
        @ok="handleOk"
        @cancel="handleCancel"
    >
      <a-form :form="form" @submit="handleOk">
        <a-form-item
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
            label="合作方名称"
        >
          <a-input
              v-decorator="[
                'partnerName',
                {
                  rules: [{ required: true, message: '请输入名称' }]
                }
              ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-layout>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import { tsFormat } from "@/components/DateUtils";
import {delPartner, listPartners, savePartner} from "@/views/partner/PartnerApi";

const tblColumns = [
  {
    title: "合作方名称",
    dataIndex: "partnerName",
    width: "50%"
  },
  {
    title: "创建人",
    dataIndex: "createUserName",
    width: "10%"
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    width: "20%"
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: {customRender: "action"},
    width: "20%"
  }
];
const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 12 }
};

export default {
  components: { Breadcrumb },
  data() {
    return {
      tblColumns,
      formItemLayout,
      tblData: [],
      keyword: "",
      pagination: {
        size: "small",
        showQuickJumper: true
      },
      curPartnerId: "",
      loading: false,
      modelTitle: "",
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this, { name: "partnerForm" }),
      modalTitle: "新增合作方",
    };
  },
  computed: {
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    onTableChange(p) {
      this.fetchList(p.current, p.pageSize);
    },
    onSearch() {
      this.fetchList();
    },
    fetchList(pageNum = 1, pageSize = 10) {
      let params = {
        keyword: this.keyword,
        pageNum,
        pageSize
      };
      listPartners(params)
          .then(response => {
            this.loading = false;
            if (response.data.code === "FAILED") {
              console.log("服务端错误", response.data.errorMsg);
              this.$message.error("读取数据失败");
            } else {
              this.setTblData(response);
            }
          });
    },
    setTblData(response) {
      let buzData = response.data.data;
      let rltList = buzData.records;
      if (rltList) {
        rltList.forEach(item => {
          if (item.createTime) {
            item.createTime = tsFormat(item.createTime);
          }
        });
      }
      this.tblData = rltList;
      const pagination = { ...this.pagination };
      pagination.current = buzData.pageNum;
      pagination.total = buzData.total;
      pagination.pageSize = buzData.pageSize;
      pagination.showTotal = function (total, range) {
        return `当前显示 ${range[0]} - ${range[1]} 条, 共 ${total} 条`;
      };
      this.pagination = pagination;
    },
    goAdd() {
      this.modalTitle = "新增合作方";
      this.curPartnerId = "";
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue({ partnerName: "" });
      });
    },
    onEdit(record) {
      this.modalTitle = "编辑合作方";
      this.curPartnerId = record.partnerId;
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue({ partnerName: record.partnerName });
      });
    },
    handleOk() {
      this.confirmLoading = true;
      let self = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          values.partnerId = self.curPartnerId;
          savePartner(values).then(response => {
            if (response.data.code === "SUCCESS") {
              self.visible = false;
              self.confirmLoading = false;
              self.form.resetFields();
              self.fetchList();
              self.$message.success("保存成功");
            } else {
              self.confirmLoading = false;
            }
          }).catch(error => {
            this.confirmLoading = false;
            console.log(error);
          });
        }
      });
    },
    handleCancel() {
      this.form.resetFields();
      this.visible = false;
    },
    onDelete(record) {
      let self = this;
      this.$confirm({
        title: "确定要删除吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "取消",
        onOk() {
          delPartner(record.partnerId).then(resp => {
            if (resp.data.code === "SUCCESS") {
              self.$message.success("删除成功");
              self.fetchList();
            }
          });
        }
      });
    },
  }
};
</script>

<style scoped>

</style>
